import { render, staticRenderFns } from "./ModalForbiddenResource.vue?vue&type=template&id=18a66919&"
import script from "./ModalForbiddenResource.vue?vue&type=script&lang=js&"
export * from "./ModalForbiddenResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalForbiddenResource.vue?vue&type=style&index=0&id=18a66919&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports